import { selectors } from 'publisher/reducers/pageReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function usePage(selector) {
  return useSelector(state => selector(state.page), shallowEqual)
}
